// extracted by mini-css-extract-plugin
export default {"imageWrapper":"gL-z","videoWrapper":"hL-z","twoColumnImage":"iL-z","imageCarouselBtn":"jL-z","carouselNextBtn":"kL-z","carouselPrevBtn":"lL-z"};